import React from 'react';
import { Card, CardBody } from 'reactstrap';
import { Btn, H5, H3, H1, H6 } from '../../../AbstractElements';
import { Purchase } from '../../../Constant';

const SimplePricing = ({ data }) => {
  return (
    <Card className='pricing-simple text-center'>
      <CardBody>
        <H3>{data.type}</H3>
        <H1>${data.price}</H1>
        <H6 className='mb-0'>{data.subTitle}</H6>
      </CardBody>
      <Btn className='btn btn-lg btn-block' color='primary'>
        <H5 className='mb-0'>{Purchase}</H5>
      </Btn>
    </Card>
  );
};

export default SimplePricing;
